import { render, staticRenderFns } from "./forgetPass.vue?vue&type=template&id=80177ee2"
import script from "./forgetPass.vue?vue&type=script&lang=js"
export * from "./forgetPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports